export class GlobalUtil {

    private static instance: GlobalUtil;

    public currentEventID: number = -1;

    private constructor() { }

    public static getInstance(): GlobalUtil {
        if (!GlobalUtil.instance) {
            GlobalUtil.instance = new GlobalUtil();
        }

        return GlobalUtil.instance;
    }

}
